import './index.css';
import { registerServiceWorker } from './pwa';
import { runApp } from './app';

registerServiceWorker();

runApp();
